document.addEventListener('DOMContentLoaded', () => {
  const systems = document.querySelectorAll('.parts-system');

  systems.forEach((system) => {
    const slides = system.querySelectorAll(
      '[data-parts-system-drawing]'
    );

    const thumbnails = system.querySelectorAll(
      '[data-parts-system-drawing-target]'
    );

    if (!slides.length || !thumbnails.length) {
      return;
    }

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const targetIndex =
          thumbnail.dataset.partsSystemDrawingTarget;

        slides.forEach((slide) => {
          slide.classList.toggle(
            'is-active',
            slide.dataset.partsSystemDrawing === targetIndex
          );
        });

        thumbnails.forEach((item) => {
          item.classList.toggle(
            'is-active',
            item === thumbnail
          );
        });
      });
    });
  });
});